/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useState } from 'react'
import { Table, Divider, Row, Col, Button, Modal, Select, Card } from 'antd'
import styles from './index.less'
import moment from 'moment'
import { UPGRADE_ORDER_TYPE_OBJ, ROLE } from '@/utils/consts'
import { REFUND_METHODS, UPGRADE_ORDER_TYPE } from '@/utils/consts'
import ReasonModal from '../../../pages/commission/list/component/ReasonModal'

const { Option } = Select

const UpgradeOrderInfo = ({ data }) => {

  // console.log(data)
  const [initValue,setInitValue] = useState({});
  const [visible,setVisible] = useState(false);

  const columns1 = [
    {
      dataIndex: 'createdAt',
      title: '升单日期',
    //   width: 160,
      align: 'center',
      render(text) {
        return text ? moment(text).format('YYYY-MM-DD') : undefined
      }
    },
    
    {
      dataIndex: 'upgradeOrderRealAmount',
      title: '升单金额',
    //   width: 100,
      align: 'center',
      render: amount => amount >= 0 ? amount + '元' : undefined,
    },
    {
        dataIndex: 'type',
        title: '升单类型',
        // width: 100,
        align: 'center',
        render(text) {
          return text ? UPGRADE_ORDER_TYPE.find(_ => _.value === text).label : undefined
        }
    },
  ]

  const columns = [
    {
      dataIndex: 'date',
      key: 'date',
      title: '日期',
      render: (text, record) => {
        return record.paymentType === 'payment' ? (record.receiptDate && moment(record.receiptDate).format('YYYY-MM-DD')) : (record.refundDate && moment(record.refundDate).format('YYYY-MM-DD'))
      }
    },
    
    {
      dataIndex: 'commissionUserName',
      key: 'commissionUserName',
      title: '提拥人'
    },
    {
      dataIndex: 'commissionUserType',
      key: 'commissionUserType',
      title: '角色',
      render: (text) => {
        return ROLE[text] || ''
      }
    },
    {
      dataIndex: 'customerName',
      key: 'customerName',
      title: '客户姓名'
    }, {
      dataIndex: 'productName',
      key: 'productName',
      title: '商品名称'
    }, {
      dataIndex: 'amount',
      key: 'amount',
      title: '升单金额',
      render:(text)=>{
        return text&&text > 0?<font style={{color:'#52c41a'}} >{`+${text.toFixed(2)}`}</font>:<font style={{color:'#f5222d'}}>{`${text.toFixed(2)}`}</font>
      }
    },{
      dataIndex: 'type',
      key: 'type',
      title: '升单类型',
      render: (text) => {
        return UPGRADE_ORDER_TYPE_OBJ[text] || ''
      }
    } ,{
      dataIndex: 'paymentType',
      key: 'paymentType',
      title: '收款类型',
      render: (text) => {
        return text === 'payment' ? '收款' : '退款'
      }
    },{
      dataIndex: 'comment',
      key: 'comment',
      title: '备注',
      render:(text,record)=>{
        return <a onClick={()=>{ setVisible(true);setInitValue(record) }}>原因</a>
      }
    },
    
  ]

  return (
    <div className={styles.reserve}>
      <Card title='升单信息' size='small' style={{marginTop: 10}} bordered={false}>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        defaultExpandAllRows={true}
        // scroll= {{ x: 1150 }}
        // expandedRowRender={expandedRowRender}
        // expandIcon={({expanded, onExpand, record}) => record.upgradeOrderItemVos ? <span className='icon-wrapper'><span className={expanded ? 'icon-expanded' : 'icon-collapse' } onClick={onExpand} /></span> : null}
        size="small"
        rowKey="upgradeOrderLogId"
      />
      <ReasonModal visible={visible} initValue={initValue} onCancel={()=>{ setVisible(false) }}/>
      </Card>
    </div>
  )
}

export default UpgradeOrderInfo

function expandedRowRender(record) {
  const columns = [
    {
      title: '商品名称',
      dataIndex: 'productName',
    },
    {
      title: '商品分类',
      dataIndex: 'categoryName',
    //   width: 120,
    },
    // {
    //   title: '已收升单金额',
    //   dataIndex: 'realAmount',
    //   width: 140,
    //   align: 'right',
    // },
    {
      title: '单项升单金额',
      dataIndex: 'itemRiseRealAmount',
      width: 140,
      align: 'right',
    },
  ]

  if(record.upgradeOrderItemVos) {
    return (
    <Fragment>
      <h4 className='order-items-label'>升单项目明细</h4>
      <Table columns={columns} pagination={false} bordered={false} dataSource={record.upgradeOrderItemVos || []} size='small'/>
    </Fragment>)
  }else {
    return false
  }
};
